import { render, staticRenderFns } from "./ListDrivers.vue?vue&type=template&id=2b4ab370&scoped=true&"
import script from "./ListDrivers.vue?vue&type=script&lang=js&"
export * from "./ListDrivers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ab370",
  null
  
)

export default component.exports